(function () {
  function initSection(root) {
    if (!root || root.dataset.v7aReady === 'true') return;
    root.dataset.v7aReady = 'true';

    root.querySelectorAll('[data-v6a-carousel]').forEach(function (carousel) {
      var tabs = Array.from(carousel.querySelectorAll('[data-v6a-tab]'));
      var slides = Array.from(carousel.querySelectorAll('[data-v6a-slide]'));
      if (!tabs.length || !slides.length) return;

      var activeTab = tabs.find(function (tab) { return tab.classList.contains('is-active'); });
      var currentKey = activeTab ? activeTab.getAttribute('data-v6a-tab') : tabs[0].getAttribute('data-v6a-tab');

      function goTo(key) {
        var tab = tabs.find(function (item) { return item.getAttribute('data-v6a-tab') === String(key); });
        var slide = slides.find(function (item) { return item.getAttribute('data-v6a-slide') === String(key); });
        if (!tab || !slide) return;
        currentKey = String(key);
        tabs.forEach(function (item) { item.classList.toggle('is-active', item === tab); });
        slides.forEach(function (item) { item.classList.toggle('is-active', item === slide); });
      }

      function step(offset) {
        var index = tabs.findIndex(function (tab) { return tab.getAttribute('data-v6a-tab') === currentKey; });
        var nextIndex = (index + offset + tabs.length) % tabs.length;
        goTo(tabs[nextIndex].getAttribute('data-v6a-tab'));
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { goTo(tab.getAttribute('data-v6a-tab')); });
      });
      var prev = carousel.querySelector('[data-v6a-prev]');
      var next = carousel.querySelector('[data-v6a-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      goTo(currentKey);
    });

    var sectionId = root.id.replace(/^v6a-/, '');
    var mapScript = document.querySelector('[data-v7a-variant-map="' + sectionId + '"]');
    var variantMap = {};
    if (mapScript) {
      try {
        variantMap = JSON.parse(mapScript.textContent || '{}');
      } catch (error) {
        variantMap = {};
      }
    }

    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return input.value;
      return new URL(window.location.href).searchParams.get('variant');
    }

    function updateImages() {
      var map = variantMap[String(currentVariantId())];
      if (!map) return;
      root.querySelectorAll('img[data-v6a-d]').forEach(function (img) {
        var item = map[img.getAttribute('data-v6a-d')];
        if (item && item.d) img.src = item.d;
      });
      root.querySelectorAll('source[data-v6a-m]').forEach(function (source) {
        var item = map[source.getAttribute('data-v6a-m')];
        if (item && item.m) source.srcset = item.m;
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target.closest('form[action*="/cart/add"]')) window.setTimeout(updateImages, 80);
    });
    document.addEventListener('variant:change', function () { window.setTimeout(updateImages, 80); });
    updateImages();
  }

  function initAll() {
    document.querySelectorAll('.v7a-linear-fluted[id^="v6a-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
